// src/components/Header.js
import React from 'react';
import { motion } from 'framer-motion';
import '../css/header.css';

// Motion variants
const containerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { staggerChildren: 0.1 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

// Intro text
const text = "A software developer focused on building smart, scalable product solutions with modern technologies.";

function Header() {
  return (
    <>
      {/* HEADER */}
      <header>
        <div className="header-left">
          <div className="name"> &lt; Ashar Naveed /&gt;</div>
        </div>
        <a href="AsharNaveed_Software_Engineer.pdf" download className="available-badge">
          Available for hire
        </a>
      </header>

      {/* HERO SECTION */}
      <section className="hero-section">
        <motion.div
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* Profile / Visual */}
          <div className="hero-visual">
            <motion.div
              className="profile-frame"
              variants={itemVariants}
              whileHover={{ scale: 1.02, rotate: -2 }}
            >
              <div className="profile-mask">
                <img src="/images/profile-org.png" alt="Ashar Naveed" />
              </div>

              <motion.div
                className="decor-circle circle-1"
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
              />
            </motion.div>
          </div>

          {/* Hero text */}
          <motion.div
            className="hero-intro"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <motion.h1 variants={itemVariants} className="hero-title">
              Hi, I'm <span className="accent-text">Ashar</span>
            </motion.h1>
            <motion.p variants={itemVariants} className="hero-description">
              {text.split(" ").map((word, i) => (
                <motion.span
                  key={i}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: i * 0.05 + 0.5 }}
                  style={{ display: 'inline-block', marginRight: '0.25em' }}
                >
                  {word}
                </motion.span>
              ))}
            </motion.p>
          </motion.div>
        </motion.div>
      </section>
    </>
  );
}

export default Header;
